/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patient_Mad_Jellyfish_GleamInputs */

const fr_patient_mad_jellyfish_gleam = /** @type {(inputs: Patient_Mad_Jellyfish_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance programmée pour cette semaine`)
};

/**

* @param {Patient_Mad_Jellyfish_GleamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const patient_mad_jellyfish_gleam = /** @type {((inputs?: Patient_Mad_Jellyfish_GleamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patient_Mad_Jellyfish_GleamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_patient_mad_jellyfish_gleam(inputs)
});